import { HYDRATE } from 'next-redux-wrapper';
import {
  IMyAccountReducerState,
  IPropsModalConfirmation,
} from '../../interface/my-account.interface';
import * as constant from './constant';

const initialStateModalConfirmation: IPropsModalConfirmation = {
  visible: false,
  close: {
    isShowClose: false,
    textClose: 'KEMBALI',
    // onClose: () => {}, // error jika panggil store di server
  },
  ok: {
    isShowOK: false,
    textOk: 'SUBMIT',
    // onOk: () => {}, // error jika panggil store di server
  },
  confirmButtonTextClassName: '',
  title: '',
  content: null,
  mobileHeight: '',
  hideCloseHeaderButton: false,
};

export const INITIAL_STATE_MY_ACCOUNT: IMyAccountReducerState = {
  detailCustomer: null,
  isVisibleFormVehicle: false,
  formVehicle: null,
  modalConfirmationState: initialStateModalConfirmation,
  detailVehicle: null,
  isLoading: false,
  eCertificate: null,
  notifications: null,
  selectedMenu: null,
  eReceipt: null,
};

const myAccountReducer = (
  state = INITIAL_STATE_MY_ACCOUNT,
  action: { type: string; payload?: any }
) => {
  const { type, payload } = action;
  switch (type) {
    case HYDRATE:
      return { ...state, ...payload.myAccount };
    case constant.SET_STATE_MY_ACCOUNT:
      return {
        ...state,
        [payload.field]: payload.value,
      };
    case constant.SET_VISIBLE_FORM_VEHICLE:
      return {
        ...state,
        isVisibleFormVehicle: payload,
      };
    case constant.SET_STATE_FORM_VEHICLE:
      return {
        ...state,
        formVehicle: {
          ...state.formVehicle,
          [payload.field]: payload.value,
        },
      };
    case constant.RESET_MODAL_CONFIRMATION:
      return {
        ...state,
        modalConfirmationState: initialStateModalConfirmation,
      };
    case constant.SET_STATE_MODAL_CONFIRMATION:
      return {
        ...state,
        modalConfirmationState: payload.value,
      };
    case constant.SET_DETAIL_VEHICLE:
      return {
        ...state,
        detailVehicle: payload.value,
      };
    case constant.SET_IS_LOADING:
      return {
        ...state,
        isLoading: payload.value,
      };
    case constant.SET_ECERTIFICATE:
      return {
        ...state,
        eCertificate: payload.value,
      };
    case constant.SET_ERECEIPT:
      return {
        ...state,
        eReceipt: payload.value,
      };
    default:
      return state;
  }
};

export default myAccountReducer;
